namespace ui
{
	export namespace tab
	{
		export class TabPane
			extends ui.base.BaseHTMLElement<HTMLDivElement>
		{
			private m_ID: string;

			constructor( id: string )
			{
				super( 'div' );

				this.m_ID	= id;

				this.Initialize(
					{
						attr:
						{
							id: this.m_ID,
							role: 'tabpanel',
						},
						classes: [ 'tab-pane', 'fade' ],
					},
				);
			}
		}
	}
}
